import Vue from 'vue'
import VueI18n from 'vue-i18n'

// Instantiate VueI18n must be done after installing VueI18n
// Otherwise vue-i18n will throw an error
// This will no longer be needed when we move to the Composition API

Vue.use(VueI18n)
export const i18n = new VueI18n()
